import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Box, Flex, Typography } from '@web-apps/ui-shared'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100vh;
  text-align: center;
`

export const PendingVerification = () => {
  const { t } = useTranslation(['app'])

  return (
    <StyledContainer>
      <Box my={64} px={24}>
        <Flex gap={16} direction="column" align="center">
          <Typography variant="h2" fontWeight="600">
            {t('app:pending_verification.title')}
          </Typography>
          <div>
            <Typography>{t('app:pending_verification.description')}</Typography>
            <Typography>
              {t('app:pending_verification.notification')}
            </Typography>
          </div>
        </Flex>
      </Box>
    </StyledContainer>
  )
}
